/* ============================================================
   HEADER — matched set with sections/natures-header.liquid
   Real Shopify wiring:
   - Cart drawer via /cart.js, /cart/change.js (qty + remove)
   - Predictive search via Section Rendering (real Liquid prices)
     -> REQUIRES sections/hdr-predictive-search.liquid
        (the theme's own sections/predictive-search.liquid is untouched)
   - Desktop dropdowns
   - Mobile burger drawer: main menu (accordion) + category icons
   - Body scroll lock that restores scroll position (iOS safe)
   - Focus/ESC handling, re-inits on Shopify theme-editor reload
   No dependencies. Vanilla JS.
   ============================================================ */
(function () {
  var TAG = '[Header]';

  /* Must match the filename of sections/hdr-predictive-search.liquid.
     Deliberately NOT 'predictive-search' — that name belongs to the theme. */
  var PREDICTIVE_SECTION = 'hdr-predictive-search';

  function init() {
    var hdr = document.querySelector('[data-hdr]');
    if (!hdr) return;
    if (hdr.dataset.hdrReady === '1') return;
    hdr.dataset.hdrReady = '1';

    var routes = {
      cart: hdr.getAttribute('data-cart-url') || '/cart',
      search: hdr.getAttribute('data-search-url') || '/search',
      predictive: hdr.getAttribute('data-predictive-url') || '/search/suggest'
    };

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    var overlay    = $('[data-hdr-overlay]');
    var drawer     = $('[data-hdr-drawer]');
    var drawerBody = $('[data-hdr-drawer-body]');
    var drawerFoot = $('[data-hdr-drawer-foot]');
    var subtotalEl = $('[data-hdr-subtotal]');
    var countEl    = $('[data-hdr-cart-count]');
    var mobile     = $('[data-hdr-mobile]');
    var searchBox  = $('[data-hdr-search]');
    var searchIn   = $('[data-hdr-search-input]');
    var resultsEl  = $('[data-hdr-results]');
    var burgerBtn  = $('[data-hdr-burger]');
    var searchBtn  = $('[data-hdr-search-toggle]');

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    /* ---------------- Body scroll lock (keeps scroll position) ------------- */
    var lockY = 0, isLocked = false;
    function lockScroll() {
      if (isLocked) return;
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      isLocked = true;
    }
    function unlockScroll() {
      if (!isLocked) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, lockY);
      isLocked = false;
    }

    /* ---------------- Desktop dropdowns ---------------- */
    $$('[data-hdr-dropdown]').forEach(function (item) {
      var btn = $('[data-hdr-dropdown-toggle]', item);
      if (!btn) return;
      var closeTimer;
      function open(state) {
        item.classList.toggle('is-open', state);
        btn.setAttribute('aria-expanded', state ? 'true' : 'false');
      }
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        $$('[data-hdr-dropdown]').forEach(function (o) {
          o.classList.remove('is-open');
          var b = $('[data-hdr-dropdown-toggle]', o);
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        open(willOpen);
      });
      item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(true); });
      item.addEventListener('mouseleave', function () { closeTimer = setTimeout(function () { open(false); }, 140); });
    });
    document.addEventListener('click', function () {
      $$('[data-hdr-dropdown]').forEach(function (o) {
        o.classList.remove('is-open');
        var b = $('[data-hdr-dropdown-toggle]', o);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });

    /* ---------------- Panels (cart drawer + mobile menu) ---------------- */
    function closeAll() {
      if (drawer) drawer.classList.remove('is-open');
      if (mobile) mobile.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'false');
      unlockScroll();
    }
    function openPanel(el) {
      if (!el) return;
      el.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      lockScroll();
    }

    if (overlay) overlay.addEventListener('click', closeAll);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAll();
      if (searchBox) {
        searchBox.classList.remove('is-open');
        if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
      }
    });

    var dc = $('[data-hdr-drawer-close]'); if (dc) dc.addEventListener('click', closeAll);
    var mc = $('[data-hdr-mobile-close]'); if (mc) mc.addEventListener('click', closeAll);

    if (burgerBtn) {
      burgerBtn.addEventListener('click', function () {
        var willOpen = !(mobile && mobile.classList.contains('is-open'));
        if (willOpen) {
          openPanel(mobile);
          burgerBtn.setAttribute('aria-expanded', 'true');
        } else {
          closeAll();
        }
      });
    }

    /* ---------------- Mobile menu: accordion + auto-close ---------------- */
    if (mobile) {
      mobile.addEventListener('click', function (e) {
        var node = e.target;
        if (!node || node.nodeType !== 1) node = node && node.parentElement;
        if (!node) return;

        var acc = node.closest('[data-hdr-acc]');
        if (acc) {
          var sub = acc.nextElementSibling;
          var isOpen = acc.getAttribute('aria-expanded') === 'true';
          acc.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (sub && sub.hasAttribute('data-hdr-sub')) sub.classList.toggle('is-open', !isOpen);
          return;
        }

        /* any real link closes the drawer so the page nav feels instant */
        var link = node.closest('a[href]');
        if (link) closeAll();
      });
    }

    /* Close the mobile drawer if the viewport grows back to desktop */
    var mq = window.matchMedia('(min-width: 1101px)');
    var mqHandler = function (ev) { if (ev.matches) closeAll(); };
    if (mq.addEventListener) mq.addEventListener('change', mqHandler);
    else if (mq.addListener) mq.addListener(mqHandler);

    /* ---------------- Sticky offset ----------------
       The sticky header is pulled up by exactly the utility bar's height so that
       bar scrolls out of view while the category/logo row pins to the top.
       That height is responsive, so measure it and keep it in sync. */
    if (hdr.classList.contains('is-sticky')) {
      var utility = $('.hdr__utility', hdr);
      if (utility) {
        var setStickyOffset = function () {
          hdr.style.setProperty('--hdr-utility-h', utility.offsetHeight + 'px');
        };
        setStickyOffset();
        window.addEventListener('resize', setStickyOffset);
        if (window.ResizeObserver) new ResizeObserver(setStickyOffset).observe(utility);
      }
    }

    /* ---------------- Search ---------------- */
    if (searchBtn && searchBox) {
      searchBtn.addEventListener('click', function () {
        var open = searchBox.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && searchIn) searchIn.focus();
        if (!open && resultsEl) resultsEl.innerHTML = '';
      });
    }

    /* Used by the cart drawer only. Search prices are rendered by Liquid now. */
    function money(cents) {
      try {
        if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      } catch (e) {}
      return '$' + (cents / 100).toFixed(2);
    }

    /* Predictive search via the Section Rendering API.
       Shopify renders sections/hdr-predictive-search.liquid server-side and
       returns HTML, so every price is a real `money`-filtered value. We import
       only the .hdr__result rows, which drops Shopify's section wrapper div and
       keeps the `.hdr__results:empty { display:none }` rule working. */
    var searchTimer, searchSeq = 0;
    if (searchIn) {
      searchIn.addEventListener('input', function () {
        var q = searchIn.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) { if (resultsEl) resultsEl.innerHTML = ''; return; }
        searchTimer = setTimeout(function () {
          var seq = ++searchSeq; /* drop responses that arrive out of order */
          var url = routes.predictive + '?q=' + encodeURIComponent(q) +
                    '&resources[type]=product&resources[limit]=6' +
                    '&section_id=' + PREDICTIVE_SECTION;
          fetch(url)
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.text();
            })
            .then(function (html) {
              if (seq !== searchSeq || !resultsEl) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var rows = doc.querySelectorAll('.hdr__result');
              if (!rows.length) { resultsEl.innerHTML = ''; return; }
              resultsEl.innerHTML = '';
              Array.prototype.forEach.call(rows, function (row) {
                resultsEl.appendChild(document.importNode(row, true));
              });
            })
            .catch(function (err) {
              if (seq !== searchSeq) return;
              /* Fail to nothing rather than to a guessed price. */
              console.warn(TAG, 'search failed', err);
              if (resultsEl) resultsEl.innerHTML = '';
            });
        }, 220);
      });
    }

    /* ---------------- Cart ---------------- */
    function renderCart(cart) {
      if (!cart) return;
      if (countEl) {
        countEl.textContent = cart.item_count;
        if (cart.item_count > 0) countEl.removeAttribute('hidden');
        else countEl.setAttribute('hidden', '');
      }
      if (!drawerBody) return;

      if (!cart.items || !cart.items.length) {
        drawerBody.innerHTML = '<div class="hdr-empty">Your cart is empty.</div>';
        if (drawerFoot) drawerFoot.setAttribute('hidden', '');
        return;
      }

      drawerBody.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        return '<div class="hdr-line" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
          '<div class="hdr-line__info">' +
            '<div class="hdr-line__t">' + esc(it.product_title) + '</div>' +
            (variant ? '<div class="hdr-line__v">' + esc(variant) + '</div>' : '') +
            '<div class="hdr-line__qty">' +
              '<button type="button" data-hdr-qty="-1" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-hdr-qty="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="hdr-line__t">' + money(it.final_line_price) + '</div>' +
        '</div>';
      }).join('');

      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      if (drawerFoot) drawerFoot.removeAttribute('hidden');
    }

    function fetchCart(open) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          if (open) {
            if (mobile) mobile.classList.remove('is-open');
            if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'false');
            openPanel(drawer);
          }
          return cart;
        })
        .catch(function (err) { console.warn(TAG, 'cart fetch failed', err); });
    }

    function changeLine(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (err) { console.warn(TAG, 'cart update failed', err); });
    }

    if (drawerBody) {
      drawerBody.addEventListener('click', function (e) {
        var node = e.target;
        if (!node || node.nodeType !== 1) node = node && node.parentElement;
        if (!node) return;
        var btn = node.closest('[data-hdr-qty]');
        if (!btn) return;
        var row = btn.closest('[data-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line'), 10);
        var cur = parseInt(row.querySelector('.hdr-line__qty span').textContent, 10);
        var next = cur + parseInt(btn.getAttribute('data-hdr-qty'), 10);
        changeLine(line, Math.max(0, next));
      });
    }

    var ct = $('[data-hdr-cart-toggle]');
    if (ct) ct.addEventListener('click', function () { fetchCart(true); });

    /* Keep the badge in sync after any add-to-cart on the page */
    if (window.fetch && !window.__hdrFetchPatched) {
      window.__hdrFetchPatched = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        return origFetch.apply(this, args).then(function (res) {
          try {
            var url = (args[0] && args[0].url) || args[0] || '';
            if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
              setTimeout(function () { fetchCart(true); }, 60);
            }
          } catch (e) {}
          return res;
        });
      };
    }

    /* The cart count is already server-rendered by Liquid, so this initial sync
       only catches a cart changed in another tab. Push it to idle time so it
       stops competing with header/account rendering on first paint. */
    if (window.requestIdleCallback) {
      requestIdleCallback(function () { fetchCart(false); }, { timeout: 2000 });
    } else {
      setTimeout(function () { fetchCart(false); }, 500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify theme editor: re-init when the section is reloaded */
  document.addEventListener('shopify:section:load', function () {
    var h = document.querySelector('[data-hdr]');
    if (h) h.dataset.hdrReady = '';
    init();
  });
})();